//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdePovFunkcePlany.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Povolen� funkce pro pl�ny </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-20                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvrfu) GID:(Web.Dia.Ts) V1:(ixs_fun,ixp_den,aktivita,dat_od,dat_do,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdePovFunkcePlany
    export function DetailAdePovFunkcePlanyDlg(
        parentContent: GContent,
        opt: {
            /** ixs_fun */
            ixs_fun: string | null,
            /** ixp_den */
            ixp_den: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdePovFunkcePlany', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdePovFunkcePlany#",
        ixs_fun: opt ? opt.ixs_fun : undefined,
        ixp_den: opt ? opt.ixp_den : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdePovFunkcePlany
    export function SeznamAdePovFunkcePlanyDlg(
        parentContent: GContent,
        opt: {
            /** ixs_fun */
            ixs_fun: string | null,
            /** ixp_den */
            ixp_den: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdePovFunkcePlany', { }]

    const options = {
        ID: "AdmAdePovFunkcePlany#",
        ixs_fun: opt ? opt.ixs_fun : undefined,
        ixp_den: opt ? opt.ixp_den : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
